import React from "react";
import { Handle, Position } from "reactflow";

const handleStyle = {
  width: 10,
  height: 10,
  border: "2px solid #ffffff",
  borderRadius: "9999px",
  background: "#10b981", // emerald-500 for the connecting dot
  boxShadow: "0 1px 2px rgba(0,0,0,0.1)",
};

export default function AutoReplyNodeStart() {
  return (
    <div className="relative flex items-center justify-center rounded-full bg-emerald-700 border border-emerald-800 px-6 py-2.5 text-[13px] font-semibold text-white shadow-sm transition-all duration-200 hover:shadow-md hover:bg-emerald-800">
      Start
      <Handle
        type="source"
        position={Position.Bottom}
        className="cursor-default"
        style={{ ...handleStyle, bottom: -6 }}
      />
    </div>
  );
}
